import { Check, Minus } from "lucide-react";
import { money } from "@/lib/plan";

const yes = (v) => (v ? <Check className="mx-auto h-4 w-4 text-aqua" /> : <Minus className="mx-auto h-4 w-4 text-ink-3" />);
const ANALYTICS = { basic: "Basic scores", detailed: "Detailed tracking", advanced: "Detailed analytics + personalised revision" };
const per = (p) => (p.limits.period === "day" ? "/ day" : "/ month");

const ROWS = [
  ["Monthly price", (p, c) => money(p[`price_monthly${c.cur === "USD" ? "_usd" : ""}`], c.cur)],
  ["Yearly price", (p, c) => money(p[`price_yearly${c.cur === "USD" ? "_usd" : ""}`], c.cur)],
  ["AI requests", (p) => `${p.limits.ai_requests} ${per(p)}`],
  ["AI explanations", (p) => (p.limits.explanations != null ? `${p.limits.explanations} ${per(p)}` : "Within AI requests")],
  ["Quizzes", (p) => `${p.limits.quizzes} ${per(p)}`],
  ["Questions per quiz", (p) => `Up to ${p.limits.max_quiz_questions}`],
  ["Learning subjects", (p, c) => (p.limits.subject_ids ? `${p.limits.subject_ids.length} introductory` : `All ${c.subjects}`)],
  ["Difficulty levels", (p) => <span className="capitalize">{p.limits.difficulties.join(", ")}</span>],
  ["Scores & answer explanations", () => yes(true)],
  ["Daily challenge quiz", () => yes(true)],
  ["AI flashcards & saved revision", (p) => yes(p.limits.flashcards)],
  ["Interview practice with model answers", (p) => yes(p.limits.interview)],
  ["AI feedback on interview answers", (p) => yes(p.limits.interview_feedback)],
  ["Timed quizzes", (p) => yes(p.limits.timed_quiz)],
  ["Timed mock interviews", (p) => yes(p.limits.mock_tests)],
  ["20-question mock assessments", (p) => yes(p.limits.max_quiz_questions >= 20)],
  ["Progress analytics", (p) => ANALYTICS[p.limits.analytics]],
];

export function CompareTable({ plans, subjectCount, currency }) {
  const ctx = { cur: currency, subjects: subjectCount };
  return (
    <div data-testid="plan-compare-table" className="overflow-x-auto rounded-2xl border border-line bg-surface">
      <table className="w-full min-w-[640px] text-sm">
        <thead>
          <tr className="border-b border-line bg-canvas-2 text-left">
            <th className="sticky left-0 z-10 bg-canvas-2 p-4 text-xs font-semibold uppercase tracking-wider text-ink-3">Feature</th>
            {plans.map((p) => <th key={p.id} className={`p-4 text-center font-display font-bold ${p.recommended ? "bg-aqua-soft text-aqua" : "text-ink"}`}>{p.name}</th>)}
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([label, fn], i) => (
            <tr key={label} data-testid={`compare-row-${i}`} className="border-b border-line last:border-0">
              <td className="sticky left-0 z-10 bg-surface p-4 font-medium text-ink-2 shadow-[1px_0_0_rgb(var(--c-line))]">{label}</td>
              {plans.map((p) => <td key={p.id} className={`p-4 text-center text-ink ${p.recommended ? "bg-aqua-soft/50" : ""}`}>{fn(p, ctx)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
